// src/config.js

// Debug function to log detailed information
const logDebugInfo = () => {
  console.log('=== Debug Information ===');
  console.log('Current hostname:', window.location.hostname);
  console.log('Current href:', window.location.href);
  console.log('process.env:', process.env);
  if (typeof import.meta !== 'undefined') {
    console.log('import.meta.env:', import.meta.env);
  }
  console.log('=========================');
};

const getBackendUrl = () => {
  // Ensure the URL doesn't end with a slash
  const cleanUrl = (url) => {
    if (!url) return '';
    // Add protocol if missing
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    // Remove trailing slash
    return url.endsWith('/') ? url.slice(0, -1) : url;
  };

  // Log debug information
  if (typeof window !== 'undefined') {
    logDebugInfo();
  }

  // 1. Try to get the value from various sources
  let rawUrl = '';

  // Direct process.env access (Create React App)
  if (typeof process !== 'undefined' && process.env) {
    if (process.env.REACT_APP_BACKEND_URL) {
      rawUrl = process.env.REACT_APP_BACKEND_URL;
      console.log('Found REACT_APP_BACKEND_URL:', rawUrl);
    }
  }

  // Vite access
  if (!rawUrl && typeof import.meta !== 'undefined' && import.meta.env) {
    if (import.meta.env.VITE_REACT_APP_BACKEND_BASEURL) {
      rawUrl = import.meta.env.VITE_REACT_APP_BACKEND_BASEURL;
      console.log('Found VITE_REACT_APP_BACKEND_BASEURL:', rawUrl);
    }
  }

  // 2. Validate and fallback
  let finalUrl = cleanUrl(rawUrl);

  if (!finalUrl) {
    // Check if we're in production
    const isProduction =
      typeof window !== 'undefined' && (
        window.location.hostname.includes('netlify.app') ||
        window.location.hostname.includes('vercel.app') ||
        window.location.hostname === 'qadirdadkazi.com' ||
        window.location.hostname === 'www.qadirdadkazi.com'
      );

    if (isProduction) {
      console.warn('BACKEND URL NOT FOUND IN ENV VARS! Using hardcoded fallback.');
      finalUrl = "https://my-portfolio-rosy-kappa-53.vercel.app";
    } else {
      finalUrl = "http://localhost:5001";
      console.log('Using localhost URL:', finalUrl);
    }
  }

  console.log('Final backend URL being used:', finalUrl);
  return finalUrl;
};

const config = {
  BACKEND_URL: getBackendUrl(),
  apiUrl: `${getBackendUrl()}/api`,
};

console.log('Final Backend URL:', config.BACKEND_URL);

export default config;
